import { render, staticRenderFns } from "./ArrowMenu.vue?vue&type=template&id=39a014f5&scoped=true"
import script from "./ArrowMenu.vue?vue&type=script&lang=js"
export * from "./ArrowMenu.vue?vue&type=script&lang=js"
import style0 from "./ArrowMenu.vue?vue&type=style&index=0&id=39a014f5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a014f5",
  null
  
)

export default component.exports